import { useSelector } from "react-redux";

import VectorIcon from "../vectorIcon";
import LessonCardPrimary from "../lessoncards/lessonCardPrimary";


function InteractiveWelcomeLesson(props) {

  // Define variables
  const lessonGroups = useSelector((state) => state.dashboardData.lessonGroups);
  const closeModal = props.closeModal;

  let lesson;
  if( lessonGroups.length > 0 ) {
    lesson = lessonGroups[0].lessons[0];
  }


  // Screen components
  let lessonElement;
  if( lesson ) {
    lessonElement = (
      <div class='interactive-welcome-lesson-container'>
        <LessonCardPrimary lesson={lesson} />
      </div>
    );
  }


  return (
    <div class='flex-column interactive-welcome-container'>
      <div style={{width: '100%'}}>

        <div class={`interactive-welcome-body`}>

          <div style={{marginBottom: '30px'}}>
            <div class='flex-row' style={{marginBottom: '15px'}}>
              <span class='icon'>&nbsp;</span>
              <h3>Now you're ready!</h3>
              <button onClick={closeModal}>
                <VectorIcon icon='close' />
              </button>
            </div>
            <p class='has-text-centered'>Let’s jump into your first lesson</p>
          </div>

          {lessonElement}

        </div>
      </div>
    </div>
  );
}

export default InteractiveWelcomeLesson;